import { useState, SubmitEvent, SubmitEventHandler } from 'react'
import Label from '@/components/common/Label'
import { className as classNameDefault } from '@/components/common/styles'
import Panel from '@/components/common/Panel'

const Password = ({ className }: { className?: string }) => {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const handlePasswordSettings: SubmitEventHandler = (
    e: SubmitEvent<HTMLInputElement>,
  ) => {
    e.preventDefault()
    console.log({
      oldPassword,
      newPassword,
      confirmPassword,
    })
  }

  return (
    <div className={`p-4 ${className}`}>
      <Panel title="Change password">
        <form onSubmit={handlePasswordSettings}>
          <div className="grid grid-cols-2 gap-x-8 bg-gray-50 dark:bg-gray-900 text-black dark:text-white">
            <div className="col-span-2">
              <Label
                id="old-password"
                label="Old password"
                value={oldPassword}
                onChange={({ target }) =>
                  setOldPassword((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="new-password"
                label="New password"
                value={newPassword}
                onChange={({ target }) =>
                  setNewPassword((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="confirm-password"
                label="Confirm password"
                value={confirmPassword}
                onChange={({ target }) =>
                  setConfirmPassword((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 pb-2">
              <button className={`${classNameDefault} float-end`} type="submit">
                Update password
              </button>
            </div>
          </div>
        </form>
      </Panel>
    </div>
  )
}

export default Password
